import { render, staticRenderFns } from "./OrderHotelFill.vue?vue&type=template&id=2d474a4a&scoped=true"
import script from "./OrderHotelFill.vue?vue&type=script&lang=js"
export * from "./OrderHotelFill.vue?vue&type=script&lang=js"
import style0 from "./OrderHotelFill.vue?vue&type=style&index=0&id=2d474a4a&prod&lang=scss&scoped=true"
import style1 from "./OrderHotelFill.vue?vue&type=style&index=1&id=2d474a4a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d474a4a",
  null
  
)

export default component.exports